import React, { Component } from "react";
import p5 from "p5";
import SpaceMono from "../assets/fonts/SpaceMono-Regular.ttf";

export default class App extends Component {
  //React ref for div reference we pass into p5
  sketchRef = React.createRef();

  //P5 instance mode
  initSketch = (p) => {
    let canvas;
    let layer;
    let layer2;

    let w = window.innerWidth;
    let h = window.innerHeight;
    let rw = w * 0.65;

    let font;

    let a = "THERE WAS NO ROOMS\nTHAT NIGHT,";
    let b = "IN THAT TOWN,";
    let c = "FOR LOVE.";

    let lw = rw * 0.7;
    let lh = h * 0.8;

    p.preload = () => {
      font = p.loadFont(SpaceMono, font);
    };

    p.setup = () => {
      //store width and height
      //setup canvas and init values here
      canvas = p.createCanvas(rw, h);
      layer = p.createGraphics(lw, lh);
      layer2 = p.createGraphics(rw, h);

      //normal canvas
      layer.textFont(font);
      layer.background("#CC2B2B");
      layer.textSize(rw * 0.04);

      layer.push();
      layer.textAlign(p.CENTER,p.TOP);
      layer.translate(lw / 2, lh * 0.05);
      layer.text(a, 0, 0);
      layer.pop();

      layer.push();
      layer.textAlign(p.CENTER);
      layer.translate(lw / 2, lh / 2);
      layer.text(b, 0, 0);
      layer.pop();

      layer.push();
      layer.textAlign(p.CENTER,p.BOTTOM);
      layer.translate(lw / 2, lh * 0.95);
      layer.text(c, 0, 0);
      layer.pop();

      layer.strokeWeight(40);
      // layer.blendMode(p.REMOVE);
    };

    p.draw = () => {
      p.background(0);
      let wave = p.map(p.cos(p.radians(-p.frameCount * 0.4)), -1, 1, -40, 40);

      // new

      let wave1 = p.int(
        p.map(p.cos(p.radians(p.frameCount * 0.5)), -1, 1, 0, rw)
      );
      let wave2 = p.int(p.map(p.sin(p.radians(p.frameCount)), -1, 1, 0, rw));

      let sx = wave1;
      let sy = wave1;
      let sw = 100;
      let sh = h;

      let dx = wave1;
      let dy = 0;
      let dw = rw * 1.5;
      let dh = h * 1.5;

      layer2.push();
      layer2.copy(layer, sx, sy, sw, sh, dx, dy, dw, dh);
      layer2.pop();

      //show the results
      p.push();
      p.imageMode(p.CENTER);
      p.image(layer2, rw / 2, h / 2);
      p.image(layer, rw / 2, h / 2);
      p.pop();

      if (p.mouseIsPressed) {
        layer.push();
        layer.translate(-rw * 0.15, -h * 0.1);
        layer.line(p.pmouseX, p.pmouseY, p.mouseX, p.mouseY);
        layer.pop();
      }
    };

    p.windowResized = () => {
      w = window.innerWidth;
      h = window.innerHeight;
      rw = w * 0.65;
      p.resizeCanvas(rw, h);
      lw = rw * 0.7;
      lh = h * 0.8;
    };
  };

  componentDidMount() {
    //Create p5 canvas once component mounts
    this.p5Canvas = new p5(this.initSketch, this.sketchRef.current);
  }

  componentWillUnmount() {
    this.p5Canvas.remove();
    window.removeEventListener("resize", this.windowResized);
  }

  render() {
    //this div will contain the sketch canvas
    return <div className="mySketch" ref={this.sketchRef} />;
  }
}
